import { CalendarDays } from "lucide-react";
import { PageHero } from "@/components/page-hero";
import { ResultCard } from "@/components/result-card";
import { ManagedPageIntro } from "@/components/managed-page-intro";
import { getPageCopy, getPublishedContent } from "@/lib/content-store";
import { toResult } from "@/lib/content-view";

export const dynamic = "force-dynamic";

export default async function AktualisPage() { const [copy, records] = await Promise.all([getPageCopy("aktualis"), getPublishedContent("result")]); const results = records.map(toResult); return <main><PageHero eyebrow={copy.eyebrow} title={copy.title} description={copy.description} icon={CalendarDays} /><ManagedPageIntro body={copy.body} /><section className="mx-auto max-w-5xl px-6 py-16 sm:py-20"><div className="grid gap-6">{results.map((item) => <ResultCard key={item.id} item={item} />)}</div></section></main>; }
